module.exports = __webpack_public_path__ + "media/images/athletes/2900-e74fe6fade497423fdc763ba527bcdd2.png";